import { render, staticRenderFns } from "./Aktivitas.vue?vue&type=template&id=325f3843&scoped=true&lang=html&"
import script from "./Aktivitas.vue?vue&type=script&lang=js&"
export * from "./Aktivitas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "325f3843",
  null
  
)

export default component.exports